import request from "./request";

const api = {
  getInfo: "activity/getInfo",
  verifyPassword: "activity/verifyPassword",
  preorder: "activity/preorder",
};

export default {
  /** 活动详情 */
  getInfo(parameter) {
    return request({
      url: api.getInfo,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 校验预购口令 */
  verifyPassword(parameter) {
    return request({
      url: api.verifyPassword,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 活动预购下单 */
  preorder(parameter) {
    return request({
      url: api.preorder,
      method: "POST",
      data: parameter || {},
    });
  },
};
